export enum VerificationSource {
  DEEP_ID = 'deepid',
  YAPEAL = 'yapeal',
  MANUAL = 'manual'
}
